import React from 'react';
import MessageCard from 'components/MessageCard';
import { Link } from 'react-router-dom';

import StaticLayout from 'containers/Common/StaticLayout';
import testingVar from 'utils/testingVar';

const Error = () => {
  return (
    <StaticLayout data-test-id={testingVar('error')}>
      <MessageCard
        variant="error"
        title="Sorry, an error ocurred"
        subtitle={
          <>
            Please try again or visit our{' '}
            <Link
              to="https://support.yet-another-mail-merge.com/hc/en-us"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Help center
            </Link>
            .
          </>
        }
      />
    </StaticLayout>
  );
};

export default Error;
